<template>
  <div class="rule" :class="[old == 1 ? 'old_rule' : '']" v-if="old != -1">
    <b>一、什么是金币？</b>
    <span>
      金币是创客云商为答谢广大金粉长期支持和喜爱而推出的一项用户回馈权益。用户可通过完成相关任务或在商城消费获得一定数量的金币；用户可使用金币在商城进行相关权益兑换；
      金币不可转让、赠送、售卖或提现。
    </span>
    <b>二、金币可以用来做什么？</b>
    <p class="weight">1.兑换商品/优惠券</p>
    <span>
      用户可在创客云商商城app/【创客村】公众号微商城/创客云商小程序—我的—金币中，使用金币兑换商品时抵扣部分现金或兑换优惠券
    </span>
    <p class="weight">2.金币抽奖</p>
    <span>
      用户可在创客云商商城app/【创客村】公众号微商城/创客云商小程序—我的—金币中，使用金币参与幸运抽奖
    </span>
    <p class="weight">3.购物直接抵现金</p>
    <span>用户在金粉日（每月最后一周周三）下单时可使用金币，按特定比例直接抵扣现金</span>
    <i>
      详细说明：1.金币抵扣仅限7折商品使用，福利类商品不可用
      2.100金币抵扣1元人民币，满500金币可用，每单最多用金币抵扣订单实付金额的5%；
      3.消费时可使用金币数需是100的整倍数（如账户有670金币，下单可用600金币）
    </i>
    <b>三、如何获取金币</b>
    <p class="weight">1.完成指定任务</p>
    <span>
      用户可在商城-我的-金币中，完成指定任务（签到、关注公号、分享、点赞、评论等，具体任务请在【去赚金币】中查看）赚取金币，连续签到可以获得更多金币哦
    </span>
    <p class="weight">2.商城购物消费</p>
    <span>用户在商城购物消费即可获得一定金币奖励</span>
    <i>
      详细说明：
      1.金币回馈数量依据用户订单完成时商品所属品类，按照实付金额数值的一定比例计算；常规商品（7折商品）金币回馈数量会高于特殊类商品（非7折商品）（金币回馈数量会按四舍五入法取整）
      2.订单金额是指用户实际支付的金额（需付运费的商品，运费部分不计算在内）
      3.订单完成是指：订单已显示完成且未办理退货手续，金币会在订单完成后回馈到用户的账户中；金币回馈的数量以订单商品的实付金额和比例为准
    </i>
    <b>四、金币有效期和金币上限</b>
    <span>
      1.用户获得但未使用的金币，将在本年年底过期。商城将定期对过期金币进行作废处理（如2025年12月31日24：00将清空2025年度用户获得但未使用的金币）；每位用户每月最高可以获得的金币上限为3500个，超出部分不计入账户。
    </span>
    <span>2.使用金币支付的商品发生退货时，将退还使用的金币</span>
    <b>五、关于签到</b>
    <span>
      1.金币签到为30天制，每签到7天除获得金币外增加盲盒（盲盒中可开出实物奖励或产品券）每个月只可开启一次。
    </span>
    <span>
      2.表情包连连看（3种小表情，每天签到都是不同的表情包。如果连续两天表情包相同获得金币翻两倍，3天一样翻2n-1x10枚金币，以此类推。每天起始金币为10）中途中断签可以补签（50金币补签一次）。
    </span>
    <b>六、其他</b>
    <p>在法律法规的允许下，创客云商拥有最终解释权。</p>
  </div>
</template>

<script>
import { isWeixin, fenxiang } from '../../assets/common/js/config'
export default {
  name: 'integralRule',
  data() {
    return {
      old: -1
    }
  },
  mounted() {
    this.old = this.$route.query.old || 0
    if (isWeixin()) {
      fenxiang({ path: 'integralrule' })
    }
  }
}
</script>

<style lang="scss">
.rule {
  /*min-height: 100%;*/
  background: #fff;
  padding: 0.1rem 0.11rem;
  /*font-family:'PingFangSC';*/
  > b {
    display: block;
    font-size: 0.15rem;
    color: rgba(68, 68, 68, 1);
    line-height: 0.21rem;
    margin-bottom: 0.1rem;
    padding-top: 0.27rem;
    &:first-of-type {
      padding-top: 0;
    }
  }
  > p {
    font-size: 0.12rem;
    font-weight: 400;
    color: rgba(92, 91, 91, 1);
    line-height: 0.15rem;
    margin-bottom: 0.09rem;
  }
  > span {
    display: block;
    font-size: 0.12rem;
    font-weight: 400;
    color: rgba(92, 91, 91, 1);
    line-height: 0.15rem;
    margin-bottom: 0.03rem;
    /*&:last-of-type {*/
    /*margin-bottom: 0;*/
    /*}*/
  }
  > i {
    display: block;
    font-size: 0.12rem;
    font-weight: 400;
    color: #ccc;
    line-height: 0.15rem;
    margin-bottom: 0.03rem;
    font-style: normal;
  }
  .weight {
    font-weight: 600;
  }
}
.rule.old_rule {
  > b {
    font-size: 0.21rem;
  }
  > span {
    font-size: 0.17rem;
    line-height: 0.24rem;
  }
  > p {
    font-size: 0.18rem;
    line-height: 0.24rem;
  }
  > i {
    font-size: 0.17rem;
    line-height: 0.24rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/integral/integralRule.vue